import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import detail from '@/views/detail'

Vue.use(Router)

export default new Router({
  base:'/year20/',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/detail',
      name: 'index',
      component: detail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js